import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';

import {
    Typography,
    Container,
    Stack,
    Box,
    IconButton,
    Divider,
    List,
    ListItem,
    ListItemButton,
    Drawer,
    ListItemText
} from '@mui/material';

//asset
import { CloseOutlined, RightOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { FaAngleDown } from 'react-icons/fa';

import { logout, activeLogin } from 'store/reducers/auth';
import StickyHeader from './StickyHeader';

const menuItems = [
    { id: 'dashboard', title: 'Sample', url: '/client/sample' },
    { id: 'point', title: '포인트', url: '/client/point' },
    { id: 'order', title: '주문하기', url: '', category: true },
    { id: 'order_blog', title: '블로그', url: '/client/order?type=blog' },
    { id: 'order_cafe', title: '카페 [점검]', url: '/client/order?type=cafe' },
    { id: 'order_intellect', title: '지식인 [점검]', url: '/client/order?type=intellect' },
    { id: 'order_media', title: '언론보도 [점검]', url: '/client/order?type=media' },
    { id: 'tools', title: '도구', url: '', category: true },
    { id: 'tools_algorithm', title: '알고리즘 분석', url: '/client/algorithm' },
    { id: 'service', title: '고객센터', url: '', category: true },
    { id: 'service_notice', title: '공지사항', url: '/client/service-notice' },
    { id: 'service_faq', title: 'FAQ', url: '/client/service-faq' },
    { id: 'service_question', title: '1:1문의', url: '/client/service-question' }
];

const useStyles = makeStyles({
    root: {
        backgroundColor: 'white',
        position: 'fixed',
        width: '100%',
        top: 0,
        padding: '15px',
        boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
        animation: 'headerSlideDown 0.8s ease forwards'
    }
});

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const sticky = StickyHeader(100);
    const classes = useStyles();
    const isLoggedIn = useSelector((state) => state.auth.client.isLoggedIn);

    const [openMenu, setOpenMenu] = useState(false);

    const onCloseDrawer = () => {
        setOpenMenu(false);
    };

    const openLogin = () => {
        dispatch(activeLogin({ open: true }));
        onCloseDrawer();
    };

    const handleLogout = () => {
        dispatch(logout({ type: 'client' }));
        onCloseDrawer();
        navigate('/client/home');
    };

    const selectMenu = (tab) => {
        // setCurTab(tab.id);
        navigate(tab.url);
        setOpenMenu(false);
    };

    return (
        <>
            <header style={{ width: '100%', position: 'absolute', zIndex: 4, top: 0 }}>
                <Box
                    p={{ md: '20px 0', xs: '30px 10px 10px 20px' }}
                    sx={{ transition: 'all 0.3s ease-in-out' }}
                    className={sticky ? classes.root : ''}
                >
                    <Container>
                        <Stack direction="row" alignItems="center">
                            <Typography variant="h5" component={Link} to="/client/home" color="black">
                                원고판다 V1.0.4
                            </Typography>
                            <Box pl={{ md: '140px' }} display={{ xs: 'none', md: 'block' }}>
                                <nav>
                                    <ul className="mainmenu">
                                        <li>
                                            <Link to="/client/sample">Sample</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link to="#">
                                                주문하기 <FaAngleDown />
                                            </Link>
                                            <ul className="axil-submenu">
                                                <li>
                                                    <Link to="/client/order?type=blog">블로그</Link>
                                                </li>
                                                <li>
                                                    <Link to="/client/order?type=cafe">카페 [점검]</Link>
                                                </li>
                                                <li>
                                                    <Link to="/client/order?type=intellect">지식인 [점검]</Link>
                                                </li>
                                                <li>
                                                    <Link to="/client/order?type=media">언론보도 [점검]</Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <Link to="/client/point">포인트</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link to="#">
                                                도구 <FaAngleDown />
                                            </Link>
                                            <ul className="axil-submenu">
                                                <li>
                                                    <Link
                                                        to="/client/algorithm"
                                                        onClick={(e) => e.preventDefault()}
                                                        style={{ pointerEvents: 'none', color: 'grey' }}
                                                    >
                                                        알고리즘 분석 [점검]
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link to="#">
                                                고객센터 <FaAngleDown />
                                            </Link>
                                            <ul className="axil-submenu">
                                                <li>
                                                    <Link to="/client/service-notice">공지사항</Link>
                                                </li>
                                                <li>
                                                    <Link to="/client/service-faq">FAQ</Link>
                                                </li>
                                                <li>
                                                    <Link to="/client/service-question">1:1문의</Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>
                            </Box>
                            <Stack mr="50px" flex={1} alignItems="flex-end" visibility={{ md: 'visible', xs: 'hidden' }}>
                                {!isLoggedIn ? (
                                    <Typography variant="h6" color="black" component={Link} to="#" onClick={openLogin}>
                                        들어가기
                                    </Typography>
                                ) : (
                                    <Stack direction="row" spacing={3}>
                                        <Typography variant="h6" component={Link} to="/client/profile" color="black">
                                            마이페이지
                                        </Typography>
                                        <Typography variant="h6" component={Link} to="/client/home" color="black" onClick={handleLogout}>
                                            나가기
                                        </Typography>
                                    </Stack>
                                )}
                            </Stack>
                            <Stack display={{ md: 'none', xs: 'block' }}>
                                <IconButton onClick={() => setOpenMenu(true)} sx={{ borderRadius: '50%', bgcolor: '#ecf2f6' }}>
                                    <UnorderedListOutlined style={{ color: 'black' }} />
                                </IconButton>
                            </Stack>
                        </Stack>
                    </Container>
                </Box>
            </header>

            <Drawer anchor="left" open={openMenu} onClose={onCloseDrawer} sx={{ display: { md: 'none', xs: 'block' } }}>
                <Box role="presentation" p="30px 16px" width="80vw">
                    <Stack direction="row" justifyContent="space-between" alignItems="center" pl={2}>
                        <Typography variant="h6" component={Link} to="/client/home" color="black" onClick={onCloseDrawer}>
                            원고판다 V1.0.4
                        </Typography>
                        <IconButton onClick={onCloseDrawer}>
                            <CloseOutlined />
                        </IconButton>
                    </Stack>
                    <Stack pt={1}>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <List sx={{ pl: 2, pr: 2 }}>
                            {menuItems.map((item) => (
                                <ListItem key={item.id} disablePadding>
                                    {item.category ? (
                                        <ListItemText sx={{ py: '10px' }}>
                                            <Stack spacing={1} borderLeft="5px solid #1890ff60" borderBottom="1px solid #1890ff60">
                                                {/*<Box width="4px" height="16px" bgcolor="#ff4f4f" />*/}
                                                <Typography fontWeight="bold" ml="5px">
                                                    {item.title}{' '}
                                                </Typography>
                                            </Stack>
                                        </ListItemText>
                                    ) : (
                                        <ListItemButton sx={{ px: '15px', py: '8px' }} onClick={() => selectMenu(item)}>
                                            <Stack direction="row" justifyContent="space-between" flex={1} alignItems="center">
                                                <Typography variant="body1">{item.title} </Typography>
                                                <RightOutlined style={{ color: '#c0c0c0', fontSize: '11px' }} />
                                            </Stack>
                                        </ListItemButton>
                                    )}
                                </ListItem>
                            ))}
                            <Divider />
                            {!isLoggedIn ? (
                                <ListItem key="login" disablePadding>
                                    <ListItemButton sx={{ px: '15px', py: '15px' }} onClick={openLogin}>
                                        <Typography variant="body1">들어가기</Typography>
                                    </ListItemButton>
                                </ListItem>
                            ) : (
                                <>
                                    <ListItem key="login" disablePadding>
                                        <ListItemButton
                                            sx={{ px: '15px', py: '10px' }}
                                            onClick={() => {
                                                navigate('/client/profile');
                                                setOpenMenu(false);
                                            }}
                                        >
                                            <Typography variant="body1">마이페이지</Typography>
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem key="login" disablePadding>
                                        <ListItemButton sx={{ px: '15px', py: '10px' }} onClick={handleLogout}>
                                            <Typography variant="body1">나가기</Typography>
                                        </ListItemButton>
                                    </ListItem>
                                </>
                            )}
                        </List>
                    </Stack>
                </Box>
            </Drawer>
        </>
    );
};

export default Header;
